import { render, staticRenderFns } from "./blNoList.vue?vue&type=template&id=4310c647&scoped=true&"
import script from "./blNoList.vue?vue&type=script&lang=js&"
export * from "./blNoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310c647",
  null
  
)

export default component.exports